import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// No props are needed for this simplified version
const ServiceBreadcrumb = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // This checks if there is a page to go back to in the current session's history
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      // If not, navigate to a fallback page, replacing the current history entry
      navigate('/explore', { replace: true });
    }
  };

  return (
    <div className="mb-6 flex items-center text-sm text-brand-slate">
      <button onClick={handleBack} className="flex items-center font-medium transition-colors hover:text-brand-ink">
        <ChevronLeft className="mr-1 h-4 w-4" />
        <span>Back to Services</span>
      </button>
      {/* Category and Name sections are removed */}
    </div>
  );
};

export default ServiceBreadcrumb;
